import React from "react";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import CircularProgress from "@material-ui/core/CircularProgress";
import { gql, useLazyQuery } from "@apollo/client";

const GET_AUTOCOMPLETE_RESULTS = gql`
  query searchResultsQuery(
    $searchString: String
    $playerId: Int
    $schoolId: Int
  ) {
    Player(id: $playerId, first: 1) {
      id
      name
    }
    School(id: $schoolId, first: 1) {
      id
      name: short_name
    }
    PlayerTeamSearch(searchString: $searchString, first: 10) {
      id
      type
      name
    }
  }
`;

export default function AutocompleteInput(props) {
  const { type, id, onChange } = props;
  const [open, setOpen] = React.useState(false);
  const [searchTerm, setSearchTerm] = React.useState("");
  const [autoCompleteValue, setAutoCompleteValue] = React.useState("");
  const [initialLoad, setInitialLoad] = React.useState(true);

  const [execute, { loading, data, error }] = useLazyQuery(
    GET_AUTOCOMPLETE_RESULTS,
    {
      variables: {
        playerId: type === "Player" ? id : null,
        schoolId: type === "School" ? id : null,
        searchString: searchTerm
      }
    }
  );

  React.useEffect(() => {
    if (!loading && !error && data) {
      if (initialLoad && data.Player?.length > 0) {
        setAutoCompleteValue(data.Player[0].name);
      } else if (initialLoad && data.School?.length > 0) {
        setAutoCompleteValue(data.School[0].name);
      }
      setInitialLoad(false);
    }
  }, [initialLoad, loading, data, error]);

  React.useEffect(() => {
    if ((initialLoad && id) || (searchTerm && searchTerm.length >= 2)) {
      execute();
    }
  }, [id, initialLoad, searchTerm, execute]);

  return (
    <Autocomplete
      style={{ width: 300 }}
      open={open}
      onOpen={() => {
        setOpen(true);
      }}
      onClose={() => {
        setOpen(false);
      }}
      value={autoCompleteValue}
      getOptionSelected={(option, value) => option.name === value.name}
      getOptionLabel={option => option?.name || option || ""}
      options={data ? data.PlayerTeamSearch : []}
      loading={loading}
      freeSolo
      onInputChange={(_, newValue) => {
        setAutoCompleteValue(newValue);
        setSearchTerm(newValue);
      }}
      onChange={(_, newValue) => {
        if (newValue?.id) onChange(newValue);
      }}
      renderInput={params => (
        <TextField
          {...params}
          label="Player or School"
          variant="outlined"
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <React.Fragment>
                {loading ? (
                  <CircularProgress color="inherit" size={20} />
                ) : null}
                {params.InputProps.endAdornment}
              </React.Fragment>
            )
          }}
        />
      )}
    />
  );
}
